import { ClientRoutes } from "@common/constants";
import { useRouter } from "@common/hooks";
import { CALCULATOR_NAMES } from "@modules/for-you/types";
import { FC, useCallback, useMemo } from "react";
import { CalculatorLg } from "@components/Icons";
import { CALCULATOR_NAME_TO_TITLE_MAP } from "@modules/for-you/constants";
import { Typography } from "@earned/core";

interface CalculatorListItemProps {
  name: CALCULATOR_NAMES;
}

const CalculatorListItem: FC<CalculatorListItemProps> = (props) => {
  const { title, icon } = useMemo(() => {
    return {
      title: CALCULATOR_NAME_TO_TITLE_MAP[props.name],
      icon: <CalculatorLg />,
    };
  }, [props.name]);
  const router = useRouter();
  const onClick = useCallback(() => {
    router.push(ClientRoutes.ForYouCalculators + "/" + props.name);
  }, [router, props.name]);
  return (
    <div
      className="flex min-h-[232px] min-w-[210px] cursor-pointer flex-col rounded border border-purple-2-100 bg-green-50 p-4"
      onClick={onClick}
    >
      <div className="pt-2.5">{icon}</div>
      <div className="line-clamp-2 max-w-[210px] pt-3.5">
        <Typography variant="body-xl" weight="medium" color="primary">
          {title}
        </Typography>
      </div>
    </div>
  );
};

export default CalculatorListItem;
